import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {WaybillsListWrapper} from './waybills-list/WaybillsList'

const waybillsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Waybill Management',
    path: '/apps/waybill-management/waybills',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const WaybillsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='waybills'
          element={
            <>
              <PageTitle breadcrumbs={waybillsBreadcrumbs}>Waybills list</PageTitle>
              <WaybillsListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/waybill-management/waybills' />} />
    </Routes>
  )
}

export default WaybillsPage
